import { createContext, useContext } from "react";

/**
 * What the shell hands every surface.
 *
 * This is the contract the five area sessions build against, and it is
 * deliberately small — a surface should need the shell for four things and no
 * more:
 *
 *   user        the authenticated operator, from `GET /auth/me` via the
 *               application's own AuthProvider. Never a literal (C5).
 *   area        the active Y-axis area id.
 *   tab         the active X-axis tab id ("" for an area's home).
 *   overlays    open/close for drawer, modal and tooltip — the shell owns the
 *               single overlay stack so two surfaces cannot both think they are
 *               the top layer (§11.5).
 *
 * A surface that needs a fifth thing from the shell is probably reaching for
 * something that belongs in its own module.
 */
export const ShellContext = createContext(null);

export function useShell() {
  const ctx = useContext(ShellContext);
  if (!ctx) {
    throw new Error("useShell must be used inside the Cipher v1.1 shell");
  }
  return ctx;
}
